import { render, staticRenderFns } from "./payment-item.vue?vue&type=template&id=69bd009c&scoped=true&"
import script from "./payment-item.vue?vue&type=script&lang=js&"
export * from "./payment-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bd009c",
  null
  
)

export default component.exports